export default __webpack_public_path__ + "static/restroom_w.22fc84873c8572eacc601afec6183bbf.svg";